module.exports = __webpack_public_path__ + "img/cooperative0_logo30.d9cd982c.jpg";